function openEnquireBox(){
	body.addClass('enquire-open');
	$('#enquire-form-offcanvas').css({
		top:scrolld
	})
	$('#enquire-form-offcanvas .close').click(function(){
		body.removeClass('enquire-open');
	});
}